import { Text } from '@chakra-ui/react';
import {
  InDesktop,
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerBody,
  ModalOrDrawerCloseButton,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@cronos-app/components';
import { useTranslations } from 'next-intl';

import { BindView } from './BindView';
import { ToggleReminder } from './ToggleReminder';
import { UnbindView } from './UnbindView';
import { useCardBindingStore } from './useCardBindingStore';

export const CardBindingModal = () => {
  const { isOpen, isBind } = useCardBindingStore();
  const t = useTranslations();
  return (
    <>
      <ModalOrDrawer
        size={{
          base: 'full',
          desktop: 'sm',
        }}
        placement="bottom"
        isOpen={isOpen}
        onClose={useCardBindingStore.getState().close}
        scrollBehavior="inside"
        closeOnOverlayClick={false}
      >
        <ModalOrDrawerOverlay />
        <ModalOrDragDrawerContent
          p="0"
          bg="linear-gradient(0deg, #152C4B 0%, #081020 100%)"
          hideTopBorder
        >
          <ModalOrDrawerHeader>
            <Text
              bg="gradients.white-blue-title"
              bgClip="text"
              textStyle={{
                base: 'body1Bold',
                desktop: 'subtitle3',
              }}
            >
              {isBind ? t('card.Link your card') : t('card.Unlink Your Wallet')}
            </Text>
            <InDesktop>
              <ModalOrDrawerCloseButton />
            </InDesktop>
          </ModalOrDrawerHeader>
          <ModalOrDrawerBody
            p="0"
            display="flex"
            flexDir="column"
            color="brand.white"
          >
            {isBind ? <BindView /> : <UnbindView />}
          </ModalOrDrawerBody>
        </ModalOrDragDrawerContent>
      </ModalOrDrawer>
      <ToggleReminder />
    </>
  );
};
